'use strict';

import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import TextInput from 'Components/Forms/Elements/TextInput';
import TextEditor from 'Components/Forms/Elements/TextEditor';
import Select from 'Components/Forms/Elements/Select';
import FileInput from 'Components/Forms/Elements/FileInput';
import Switch from 'Components/Forms/Elements/Switch';
import Checkbox from 'Components/Forms/Elements/Checkbox';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import Grid from '@material-ui/core/Grid';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import handleFileChange from 'Components/Forms/Functions/handleFileChange';
import getStateFromObject from 'Components/Forms/Functions/getStateFromObject';
import getFormData from 'Components/Forms/Functions/getFormData';
import ScheduleConfig from 'Components/Forms/Models/CoworkingSpace/ScheduleConfig';
import ajaxRequest from 'Functions/ajax/ajaxRequest';
import bemit from 'Functions/bemit';
import { coworking_place_types as type_options, coworking_place_equipments as equipment_options, coworking_place_hybrid_equipments as hybrid_equipment_options, b_seminars_config } from 'Shared/options';
import Loader from 'Pure/Loader';
import { isTrue, num } from 'Shared/utilities';
const {
  app,
  qwest
} = window;
export default class CoworkingSpaceForm extends Component {
  state = {
    status_messages: {},
    'coworkingspace[equipments]': [],
    'coworkingspace[hybrid_equipments]': []
  };
  handleChange = handleChange.bind(this);
  handleFileChange = handleFileChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchCoworkingSpace();
    }
  }
  fetchCoworkingSpace = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/coworking-space/get-all', {
      id: props.id || document.location.pathname.split('/liste-des-espaces-coworking/')[1],
      with_count: false
    }).then(function (xhr, response) {
      let {
        images,
        equipments = [],
        hybrid_equipments = [],
        availabilities,
        pricings,
        ...coworkingspace
      } = response.data[0] || {};
      delete coworkingspace._etablishment;
      images = images.map(image => ({
        ...image,
        status: 'uploaded'
      }));
      const update = getStateFromObject({
        data: coworkingspace,
        model: 'coworkingspace'
      });
      component.setState({
        ...update,
        'coworkingspace[images]': images,
        '__files-coworkingspace[images]': images,
        'coworkingspace[equipments]': equipments,
        'coworkingspace[hybrid_equipments]': hybrid_equipments,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  handleRadioChange = event => {
    const component = this,
      props = this.props,
      state = this.state;
    const target = event.target;
    const value = target.value;
    const name = target.name;
    component.setState({
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined
    });
  };
  validate = async e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const coworkingspace = getFormData({
      state: state,
      pattern: 'coworkingspace['
    });
    const url = props.type === 'update' ? '/coworking-space/update' : '/coworking-space/create';
    try {
      var response = await ajaxRequest(url, {
        data: coworkingspace,
        files: true
      });
    } catch (e) {
      return component.setState(e);
    }
    if (props.type === 'update') {
      component.fetchCoworkingSpace();
    } else {
      window.setTimeout(function () {
        app.navigateTo('/liste-des-espaces-coworking');
      }, 2000);
    }
    component.setState({
      loading: false,
      info: response.info,
      error: undefined,
      warning: undefined,
      status_messages: {}
    });
  };
  handleHoursChange = ({
    e,
    name,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages[name];
    const numeric_value = numeral(value).value();
    let day_name = name.split('coworkingspace[schedule][')[1] || '';
    if (day_name.includes('[')) {
      day_name = day_name.slice(0, day_name.indexOf('[') - 1);
    }
    const space_type = state['coworkingspace[type]'];
    const is__half_type = space_type !== 'a_calm_coworking_space';
    const pattern = 'coworkingspace[schedule][' + day_name + '][';
    let half_name = is__half_type ? name.split(pattern)?.[1]?.split('_')?.[0] || '' : '';
    const from = is__half_type ? pattern + half_name + '_from]' : pattern + 'from]';
    const to = is__half_type ? pattern + half_name + '_to]' : pattern + 'to]';
    const update = {
      [name]: value,
      info: undefined,
      error: undefined,
      warning: undefined,
      status_messages: status_messages
    };
    if (numeric_value >= state[to] && name === from) {
      update[to] = numeral(value).add(1).format('0');
    }
    if (numeric_value <= state[from] && name === to && value !== '0') {
      update[from] = numeral(value).subtract(1).format('0');
    }
    return component.setState(update);
  };
  handleEquipmentChange = ({
    e,
    name,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages["coworkingspace[equipments]"];
    let equipments = state["coworkingspace[equipments]"].slice(0);
    if (equipments.includes(name)) {
      equipments = equipments.filter(equipment => equipment !== name);
      component.setState({
        "coworkingspace[equipments]": equipments,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state["coworkingspace[equipments]"];
      equipments.push(name);
      component.setState({
        "coworkingspace[equipments]": equipments,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  handleHybridEquipmentChange = ({
    e,
    name,
    value
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    let status_messages = state.status_messages;
    delete status_messages["coworkingspace[hybrid_equipments]"];
    let hybrid_equipments = state["coworkingspace[hybrid_equipments]"].slice(0);
    if (hybrid_equipments.includes(name)) {
      hybrid_equipments = hybrid_equipments.filter(equipment => equipment !== name);
      component.setState({
        "coworkingspace[hybrid_equipments]": hybrid_equipments,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    } else {
      delete state["coworkingspace[hybrid_equipments]"];
      hybrid_equipments.push(name);
      component.setState({
        "coworkingspace[hybrid_equipments]": hybrid_equipments,
        info: undefined,
        error: undefined,
        warning: undefined,
        status_messages: status_messages
      });
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const space_type = state['coworkingspace[type]'];
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let equipments = equipment_options.map(function (equipment) {
      let output = /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 4,
        key: equipment.value
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: component.handleEquipmentChange,
        label: equipment.label || equipment.value,
        name: equipment.value,
        value: state['coworkingspace[equipments]'].includes(equipment.value),
        status: state.status_messages
      }));
      return output;
    });
    let hybrid_equipments = hybrid_equipment_options.map(function (hybrid_equipment) {
      let output = /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        sm: 6,
        md: 6,
        lg: 4,
        key: hybrid_equipment.value
      }, /*#__PURE__*/React.createElement(Checkbox, {
        onChange: component.handleHybridEquipmentChange,
        label: hybrid_equipment.label || hybrid_equipment.value,
        name: hybrid_equipment.value,
        value: (state['coworkingspace[hybrid_equipments]'] || []).includes(hybrid_equipment.value),
        status: state.status_messages
      }));
      return output;
    });
    const b_seminar_cancel_fields = space_type === "b_seminar" ? /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4,
      className: "u-flex u-items-center"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state['coworkingspace[cancellation_condition]'] === "non_remboursable",
      onChange: component.handleRadioChange,
      value: "non_remboursable",
      color: "primary",
      name: "coworkingspace[cancellation_condition]"
    }), "R\xE9servation non remboursable"), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4,
      className: "u-flex u-items-center"
    }, /*#__PURE__*/React.createElement(Radio, {
      checked: state['coworkingspace[cancellation_condition]'] === "annulation_possible",
      onChange: component.handleRadioChange,
      value: "annulation_possible",
      color: "primary",
      name: "coworkingspace[cancellation_condition]"
    }), "Annulation possible X jours avant l\u2019arriv\xE9e"), state["coworkingspace[cancellation_condition]"] === "annulation_possible" ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[cancellation_condition_duration]'],
      name: "coworkingspace[cancellation_condition_duration]",
      type: "text",
      "allow-negative": false,
      "safe-value": true,
      int: true,
      label: "Jour(s)",
      status: state.status_messages
    })) : undefined) : undefined;
    const calm_space_conditions = space_type !== 'c_open_coworking_space' ? /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/React.createElement("h3", {
      className: "back-title u-full-width "
    }, "D\xE9lai minimum avant r\xE9servation"), /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[cancel_h_delta]'],
      name: "coworkingspace[cancel_h_delta]",
      type: "text",
      "allow-negative": false,
      "safe-value": true,
      int: true,
      label: "Heure(s) avant d\xE9but du cr\xE9neau r\xE9serv\xE9",
      status: state.status_messages
    })), space_type === 'a_calm_coworking_space' ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      md: 6
    }, /*#__PURE__*/React.createElement("h3", {
      className: "back-title u-full-width "
    }, "Conditions d'annulation"), /*#__PURE__*/React.createElement("p", null, "Annulation possible H-4")) : undefined) : undefined;
    const is__half_type = space_type !== 'a_calm_coworking_space';
    const free_conditions_area = space_type === 'c_open_coworking_space' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      spacing: 2,
      xs: 12,
      sm: 6,
      md: 4,
      lg: 4,
      className: "u-flex u-items-end"
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: isTrue(state['coworkingspace[custom_free_conditions]']),
      name: "coworkingspace[custom_free_conditions]",
      label: "Forfait obligatoire de consommation",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      spacing: 2,
      xs: 12,
      sm: 5,
      md: 3,
      lg: 2,
      classes: props.classes
    }, isTrue(state['coworkingspace[custom_free_conditions]']) ? /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[custom_free_price]'],
      name: "coworkingspace[custom_free_price]",
      label: "Prix du forfait",
      "safe-value": true,
      status: state.status_messages
    }) : undefined), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      spacing: 2,
      xs: 12,
      sm: 7,
      md: 9,
      lg: 10,
      classes: props.classes
    }, isTrue(state['coworkingspace[custom_free_conditions]']) ? /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[custom_free_text]'],
      name: "coworkingspace[custom_free_text]",
      label: "D\xE9tail du forfait",
      status: state.status_messages,
      placeholder: "Ex: Une viennoiserie et une boisson chaude ou Boissons chaudes \xE0 volont\xE9..."
    }) : undefined)) : undefined;
    const left_config = /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      xl: is__half_type ? 12 : 6
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[name]'],
      name: "coworkingspace[name]",
      type: "text",
      label: "Nom de l'espace",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: free_conditions_area ? 4 : 8,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(Select, {
      onChange: component.handleChange,
      value: space_type,
      name: "coworkingspace[type]",
      label: "Type",
      status: state.status_messages,
      options: type_options,
      defaultValue: type_options[0]?.value
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(Switch, {
      onChange: component.handleChange,
      value: state["coworkingspace[isActive]"],
      name: "coworkingspace[isActive]",
      "top-label": "Statut",
      label: "Activ\xE9",
      "left-label": "D\xE9sactiv\xE9",
      status: state.status_messages
    })), free_conditions_area, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(TextEditor, {
      onChange: component.handleChange,
      value: state["coworkingspace[description]"] || '',
      name: "coworkingspace[description]",
      label: "Description",
      multiline: true,
      rows: "5",
      "without-headings": true,
      className: "custom-editor",
      status: state.status_messages
    }))));
    const seminar_disposition = space_type === 'b_seminar' ? Object.keys(b_seminars_config) : [];
    const dispositions = seminar_disposition.map(function (key) {
      let name = 'coworkingspace[disposition_seat][' + key + '][place]';
      const output = /*#__PURE__*/React.createElement(Grid, {
        item: true,
        spacing: 2,
        key: key,
        xs: 12,
        sm: 6,
        md: 4,
        lg: 3,
        classes: props.classes
      }, /*#__PURE__*/React.createElement("h4", {
        className: "back-title u-full-width "
      }, b_seminars_config[key].title), /*#__PURE__*/React.createElement(TextInput, {
        onChange: component.handleChange,
        value: state[name],
        name: name,
        label: "Places",
        type: "text",
        "safe-value": true,
        int: true,
        status: state.status_messages
      }));
      return output;
    });
    let output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: "/coworking-space/create",
      className: props.paper !== false ? 'c-paper' : undefined
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, left_config, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      xl: is__half_type ? 12 : 6,
      className: "u-text-center"
    }, /*#__PURE__*/React.createElement(ScheduleConfig, {
      onChange: component.handleChange,
      onHoursChange: component.handleHoursChange,
      type: space_type,
      state: state
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(FileInput, {
      accept: ".jpg,.jpeg,.png,.gif",
      onChange: component.handleFileChange,
      name: "coworkingspace[images]",
      data: state,
      multiple: true,
      status: state.status_messages,
      label: "Photo(s)"
    })), /*#__PURE__*/React.createElement("h3", {
      className: "back-title u-full-width "
    }, "Equipements"), equipments, space_type === 'b_seminar' ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("h3", {
      className: "back-title u-full-width "
    }, "Espace hybride"), hybrid_equipments, /*#__PURE__*/React.createElement("h3", {
      className: "back-title u-full-width "
    }, "Conditions d\u2019annulation"), b_seminar_cancel_fields) : undefined, calm_space_conditions, /*#__PURE__*/React.createElement("h3", {
      className: "back-title u-full-width "
    }, space_type === 'c_open_coworking_space' ? 'Capacité' : 'Capacité et tarifs'), space_type === "c_open_coworking_space" ? /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[number_seat]'],
      name: "coworkingspace[number_seat]",
      type: "text",
      "allow-negative": false,
      "safe-value": true,
      int: true,
      label: "Nombre de si\xE8ge",
      status: state.status_messages
    })) : space_type === "a_calm_coworking_space" ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[number_seat]'],
      name: "coworkingspace[number_seat]",
      type: "text",
      "allow-negative": false,
      "safe-value": true,
      int: true,
      label: "Nombre de si\xE8ge",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[max_number_seat]'],
      name: "coworkingspace[max_number_seat]",
      type: "text",
      "allow-negative": false,
      "safe-value": true,
      int: true,
      label: "Nombre de si\xE8ge max pour pour une m\xEAme r\xE9servation",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement("h3", {
      className: "back-title u-full-width "
    }, "Tarif horaire \xE0 la journ\xE9e"), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[schedule_price][one_three][price]'],
      name: "coworkingspace[schedule_price][one_three][price]",
      type: "text",
      "allow-negative": false,
      "safe-value": true,
      label: "de 1 \xE0 3 heures",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[schedule_price][four_seven][price]'],
      name: "coworkingspace[schedule_price][four_seven][price]",
      type: "text",
      "allow-negative": false,
      "safe-value": true,
      label: "de 4 \xE0 7 heures",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 4
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[schedule_price][height_more][price]'],
      name: "coworkingspace[schedule_price][height_more][price]",
      type: "text",
      "allow-negative": false,
      "safe-value": true,
      label: "\xE0 partir de 8 heures",
      status: state.status_messages
    }))) : space_type === "b_seminar" ? /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[disposition_seat][price_half_day]'],
      name: "coworkingspace[disposition_seat][price_half_day]",
      type: "text",
      "allow-negative": false,
      "safe-value": true,
      label: "Prix \xE0 la \xBD journ\xE9e",
      status: state.status_messages
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/React.createElement(TextInput, {
      onChange: component.handleChange,
      value: state['coworkingspace[disposition_seat][price_day]'],
      name: "coworkingspace[disposition_seat][price_day]",
      type: "text",
      "allow-negative": false,
      "safe-value": true,
      label: "Prix \xE0 la journ\xE9e",
      status: state.status_messages
    })), dispositions) : undefined), status), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center\r u-margin-top-25 u-padding-bottom-20 "
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer cet espace', loader)));
    return output;
  }
}
